import { Component } from '@angular/core';

@Component({
  selector: 'lib-sync-icon',
  standalone: true,
  imports: [],
  templateUrl: './sync-icon.component.html',
  styleUrl: './sync-icon.component.css',
})
export class SyncIconComponent {}
